export const social = {
    facebook: {
        label: "Facebook",
        href: "#",
        target: "external",
    },
    instagram: {
        label: "Instagram",
        href: "#",
        target: "external",
    },
    twitter: {
        label: "Twitter",
        href: "#",
        target: "external",
    },
};

export const legal = {
    terms: {
        label: "Terms of Use",
        href: "#",
        target: "external",
    },
    privacy: {
        label: "Privacy Policy",
        href: "#",
        target: "external",
    },
    sell: {
        label: "Do Not Sell Or Share My Personal Information",
        href: "#",
        target: "external",
    },
    choices: {
        label: "Ad Choices",
        href: "#",
        target: "external",
    },
};

export const a11y = {
    skip: {
        label: "Skip to content",
    },
};
